export const contextPath = window.ocm?.config?.encodedContextPath ?? "/de-de/shop";
export const language = window.ocm?.config?.language ?? "en";
export const isClassicSite = window.ocm?.isClassicSite ?? false;
